import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "./Layout";

export default class NoPermitido extends Component {
  render() {
    return (
      <div>
        <Layout>
          <Container>
            <Row>
              <Col className="text-center mt-5 ">
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  size="9x"
                  color="#cb3234"
                  className="animate__animated animate__shakeX"
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col className="text-center">
                <h1>No tienes permisos para acceder a esta ubicación.</h1>
              </Col>
            </Row>
          </Container>
        </Layout>
      </div>
    );
  }
}
